/* eslint-disable react/prop-types */
import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';

import NavigationBar from 'components/inc/NavigationBar.jsx';

import { timezoneList, API_END_POINTS } from 'utils/constants';

const styles = {
  gridItemPadding: {
    paddingTop: '0.25rem !important',
    paddingBottom: '0.25rem !important',
  },
};

const { BASE_URL, USER_PROFILE_URL, COUNTRIES_LIST_URL } = API_END_POINTS;

const FormMessageDisplay = ({ message, isError = false }) => {
  return (
    <Grid item xs={12} sm={12} md={12} lg={12}>
      <Alert severity={isError ? 'error' : 'success'}>{message}</Alert>
    </Grid>
  );
};

const Profile = ({
  errors,
  loadings,
  classes,
  onChange,
  updateProfileClicked,
  email,
  firstName,
  lastName,
  company,
  companyRole,
  countryWithStatesList,
  country,
  countrySpecificStatesList,
  state,
  city,
  timezone,
}) => {
  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        classes={{ item: classes.gridItemPadding }}
      >
        <TextField
          id='profile-email'
          name='email'
          label='Email'
          placeholder='Enter your email'
          fullWidth
          margin='dense'
          type='email'
          helperText={'Email change is currently not supported'}
          value={email}
          InputProps={{
            readOnly: true,
            disabled: true,
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        classes={{ item: classes.gridItemPadding }}
      >
        <TextField
          id='profile-password'
          name='password'
          label='Password'
          placeholder='Password field is disabled'
          fullWidth
          margin='dense'
          type='password'
          value={'passwordisdummy'}
          InputProps={{
            readOnly: true,
            disabled: true,
            endAdornment: (
              <InputAdornment position='end'>
                <Link to='/change-password'>
                  <Button size='small'>Change password</Button>
                </Link>
              </InputAdornment>
            ),
            autoFocus: true,
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        classes={{ item: classes.gridItemPadding }}
      >
        <TextField
          id='profile-first-name'
          name='firstName'
          label='First name'
          placeholder='Enter your first name'
          fullWidth
          margin='dense'
          type='text'
          helperText={
            errors['firstName'] && errors['firstName'] !== ''
              ? errors['firstName']
              : ''
          }
          error={errors['firstName'] && errors['firstName'] !== ''}
          value={firstName}
          onChange={onChange}
          InputProps={{
            readOnly: loadings['isUpdatingProfile'],
            autoFocus: true,
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        classes={{ item: classes.gridItemPadding }}
      >
        <TextField
          id='profile-last-name'
          name='lastName'
          label='Last name'
          placeholder='Enter your last name'
          InputProps={{
            readOnly: loadings['isUpdatingProfile'],
          }}
          fullWidth
          margin='dense'
          type='text'
          helperText={
            errors['lastName'] && errors['lastName'] !== ''
              ? errors['lastName']
              : ''
          }
          error={errors['lastName'] && errors['lastName'] !== ''}
          value={lastName}
          onChange={onChange}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        classes={{ item: classes.gridItemPadding }}
      >
        <TextField
          id='profile-company'
          name='company'
          label='Company'
          placeholder='Enter your company name'
          InputProps={{
            readOnly: loadings['isUpdatingProfile'],
          }}
          fullWidth
          margin='dense'
          type='text'
          helperText={
            errors['company'] && errors['company'] !== ''
              ? errors['company']
              : ''
          }
          error={errors['company'] && errors['company'] !== ''}
          value={company}
          onChange={onChange}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        classes={{ item: classes.gridItemPadding }}
      >
        <TextField
          id='profile-role'
          name='companyRole'
          label='Role in company'
          placeholder='Enter role in your company'
          InputProps={{
            readOnly: loadings['isUpdatingProfile'],
          }}
          fullWidth
          margin='dense'
          type='text'
          helperText={
            errors['companyRole'] && errors['companyRole'] !== ''
              ? errors['companyRole']
              : ''
          }
          error={errors['companyRole'] && errors['companyRole'] !== ''}
          value={companyRole}
          onChange={onChange}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        classes={{ item: classes.gridItemPadding }}
      >
        <TextField
          id='profile-country'
          name='country'
          label='Country'
          placeholder='Select your country'
          select
          InputProps={{
            readOnly:
              loadings['isUpdatingProfile'] || loadings['isFetchingCountries'],
          }}
          helperText={
            errors['country'] && errors['country'] !== ''
              ? errors['country']
              : ''
          }
          error={errors['country'] && errors['country'] !== ''}
          fullWidth
          margin='dense'
          type='text'
          value={country}
          onChange={onChange}
        >
          <MenuItem disabled>Select your Country</MenuItem>
          {countryWithStatesList.map((item) => (
            <MenuItem key={item.countryCode} value={item.countryCode}>
              {item.countryName}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        classes={{ item: classes.gridItemPadding }}
      >
        <TextField
          id='profile-state'
          name='state'
          label='State'
          placeholder='Select your state'
          select
          InputProps={{
            readOnly:
              loadings['isUpdatingProfile'] || loadings['isFetchingCountries'],
          }}
          helperText={
            errors['state'] && errors['state'] !== '' ? errors['state'] : ''
          }
          error={errors['state'] && errors['state'] !== ''}
          fullWidth
          margin='dense'
          type='text'
          value={state}
          onChange={onChange}
        >
          <MenuItem disabled>Select your State/Territory</MenuItem>
          {countrySpecificStatesList.map((item) => (
            <MenuItem key={item.stateCode} value={item.stateCode}>
              {item.stateName}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        classes={{ item: classes.gridItemPadding }}
      >
        <TextField
          id='profile-city'
          name='city'
          label='City'
          placeholder='Enter your city'
          InputProps={{
            readOnly: loadings['isUpdatingProfile'],
          }}
          fullWidth
          margin='dense'
          type='text'
          value={city}
          onChange={onChange}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        classes={{ item: classes.gridItemPadding }}
      >
        <TextField
          id='profile-time-zone'
          name='timezone'
          label='Timezone'
          placeholder='Select your timezone'
          select
          InputProps={{
            readOnly: loadings['isUpdatingProfile'],
          }}
          fullWidth
          margin='dense'
          type='text'
          helperText={
            errors['timezone'] && errors['timezone'] !== ''
              ? errors['timezone']
              : ''
          }
          error={errors['timezone'] && errors['timezone'] !== ''}
          value={timezone}
          onChange={onChange}
        >
          <MenuItem disabled>Select your Timezone</MenuItem>
          {timezoneList.map((item) => (
            <MenuItem key={item.timezone} value={item.timezone}>
              ({item.display}) {item.timezone}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ textAlign: 'center' }}
      >
        <Button
          variant='contained'
          color='primary'
          onClick={updateProfileClicked}
          disabled={
            loadings['isUpdatingProfile'] ||
            loadings['isFetchingProfile'] ||
            loadings['isFetchingCountries']
          }
        >
          {loadings['isUpdatingProfile'] ? (
            <CircularProgress size={30} />
          ) : (
            'Update profile'
          )}
        </Button>
      </Grid>
    </>
  );
};

class ProfilePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      firstName: '',
      lastName: '',
      company: '',
      companyRole: '',
      country: '',
      countryWithStatesList: [],
      countrySpecificStatesList: [],
      state: '',
      city: '',
      profiles: [],
      message: '',
      timezone: '',
      userData: {},
      loadings: {
        isUpdatingProfile: false,
        isFetchingProfile: true,
        isFetchingCountries: true,
      },
      errors: {
        firstName: '',
        lastName: '',
        company: '',
        companyRole: '',
        country: '',
        state: '',
        timezone: '',
        form: '',
      },
      successes: {
        form: '',
      },
    };
  }

  async componentDidMount() {
    const authToken = localStorage.getItem('accessToken');
    const userID = localStorage.getItem('userID');

    await this.fetchCountryList(authToken);
    await this.fetchUserDetails(authToken, userID);
  }

  onChange = (e) => {
    const {
      target: { value, name },
    } = e;
    this.setState({
      [name]: value,
      errors: { ...this.state.errors, [name]: '', form: '' },
      successes: { form: '' },
    });

    if (name === 'country') {
      this.setState({
        state: '',
      });
      this.updateStatesListBasedOnCountry(value);
    }
  };

  async fetchCountryList(authToken) {
    try {
      const response = await axios({
        method: 'get',
        url: `${BASE_URL}${COUNTRIES_LIST_URL}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.data) {
        const {
          data: { data: rawCountryData },
        } = response;

        const countryWithStatesList = rawCountryData.map((countryData) => ({
          countryCode: countryData.alpha2code,
          countryName: countryData.name,
          states: countryData.states.map((statesData) => ({
            stateCode: statesData.code,
            stateName: statesData.name,
          })),
        }));

        this.setState({
          countryWithStatesList,
          loadings: { ...this.state.loadings, isFetchingCountries: false },
        });
      } else {
        throw new Error('failed to list countries');
      }
    } catch (err) {
      this.setState({
        loadings: { ...this.state.loadings, isFetchingCountries: false },
        errors: {
          ...this.state.errors,
          form:
            'Oh looks like we failed to list countries, you can go ahead and update other fields.',
          country: "Couldn't load countries list",
          state: "Couldn't load states list",
        },
      });

      console.error('Err in fetching countries', err);
    }
  }

  async fetchUserDetails(authToken, userID) {
    try {
      const response = await axios({
        method: 'get',
        url: `${BASE_URL}${USER_PROFILE_URL}/${userID}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response && response.data) {
        const {
          data: {
            email = '',
            firstName = '',
            lastName = '',
            companyRole = '',
            company = '',
            timezone = '',
            profiles = [],
          },
        } = response.data;

        let country = '';
        let state = '';
        let city = '';

        if (profiles.length !== 0) {
          for (const profile of profiles) {
            // Checking if any of the location info is present in each profile
            if (
              profile &&
              profile.location &&
              (profile.location.country ||
                profile.location.state ||
                profile.location.city)
            ) {
              country = profile.location.country
                ? profile.location.country
                : '';
              state = profile.location.state ? profile.location.state : '';
              city = profile.location.city ? profile.location.city : '';
            }
          }
        }

        this.setState({
          email,
          firstName,
          lastName,
          companyRole,
          company,
          country,
          state,
          city,
          timezone,
          profiles,
          loadings: { ...this.state.loadings, isFetchingProfile: false },
        });

        if (country && country.length !== 0) {
          this.updateStatesListBasedOnCountry(country);
        }
      } else {
        throw new Error("Couldn't load your user details");
      }
    } catch (err) {
      this.setState({
        loadings: { ...this.state.loadings, isFetchingProfile: false },
        errors: {
          ...this.state.errors,
          form:
            "Well, this is embarrassing, we couldn't load your user details, try refreshing the page",
        },
      });

      console.error('Failed to fetch user details', err);
    }
  }

  isFormValid = () => {
    let errors = {};

    const { firstName, lastName, company, companyRole, timezone } = this.state;

    if (firstName.trim().length === 0) {
      errors = { ...errors, firstName: 'First name cannot be left blank' };
    } else if (firstName.length > 30) {
      errors = {
        ...errors,
        firstName: 'First name should be less than 30 characters',
      };
    }

    if (lastName.trim().length === 0) {
      errors = { ...errors, lastName: 'Last name cannot be left blank' };
    } else if (lastName.length > 30) {
      errors = {
        ...errors,
        lastName: 'Last name should be less than 30 characters',
      };
    }

    if (company.trim().length === 0) {
      errors = { ...errors, company: 'Company cannot be left blank' };
    } else if (company.length > 30) {
      errors = {
        ...errors,
        company: 'Company name should be less than 30 characters',
      };
    }

    if (companyRole.trim().length === 0) {
      errors = {
        ...errors,
        companyRole: 'Role in company cannot be left blank',
      };
    } else if (companyRole.length > 30) {
      errors = {
        ...errors,
        companyRole: 'Role should be less than 30 characters',
      };
    }

    if (timezone.trim().length === 0) {
      errors = {
        ...errors,
        timezone: 'Please select a time zone from the list',
      };
    }

    if (Object.keys(errors).length === 0 && errors.constructor === Object) {
      return true;
    } else {
      this.setState({
        errors,
      });
      return false;
    }
  };

  updateProfileClicked = async () => {
    const {
      firstName,
      lastName,
      company,
      companyRole,
      country,
      city,
      timezone,
      state,
      profiles,
    } = this.state;

    const authToken = localStorage.getItem('accessToken');
    const userID = localStorage.getItem('userID');
    try {
      if (this.isFormValid()) {
        this.setState({
          loadings: { ...this.state.loadings, isUpdatingProfile: true },
          errors: { ...this.state.errors, form: '' },
          successes: { ...this.state.successes, form: '' },
        });

        // Since each profile has location object, we will update all of its
        // with same location
        const profilesWithUpdatedLocation = profiles.map((profile) => ({
          ...profile,
          location: {
            country,
            state,
            city,
            timezone,
          },
        }));

        const updatedUserData = {
          firstName,
          lastName,
          company,
          companyRole,
          timezone,
          country,
          city,
          profiles: profilesWithUpdatedLocation,
        };

        const response = await axios({
          method: 'put',
          url: `${BASE_URL}${USER_PROFILE_URL}/${userID}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          data: updatedUserData,
        });

        if (response && response.status === 200) {
          this.setState({
            successes: {
              ...this.state.successes,
              form: 'Your profile is updated successfully.',
            },
            loadings: { ...this.state.loadings, isUpdatingProfile: false },
          });
        } else {
          throw new Error('Profile not updated');
        }
      }
    } catch (err) {
      console.error(err);
      this.setState({
        errors: {
          ...this.state.errors,
          form: "Well, this is embarrassing, we couldn't update your profile",
        },
        loadings: { ...this.state.loadings, isUpdatingProfile: false },
      });
    }
  };

  updateStatesListBasedOnCountry(selectedCountry) {
    const { countryWithStatesList } = this.state;
    const countryWithStates = countryWithStatesList.find(
      (country) => selectedCountry === country.countryCode
    );

    let countrySpecificStatesList = [];
    if (
      countryWithStates &&
      countryWithStates.states &&
      countryWithStates.states.length !== 0
    ) {
      countrySpecificStatesList = countryWithStates.states;
    }

    this.setState({
      countrySpecificStatesList,
    });
  }

  render() {
    const { classes } = this.props;
    const {
      email,
      firstName,
      lastName,
      company,
      companyRole,
      countryWithStatesList,
      country,
      countrySpecificStatesList,
      state,
      city,
      timezone,
      errors,
      successes,
      loadings,
    } = this.state;

    const profileStates = {
      email,
      firstName,
      lastName,
      company,
      companyRole,
      countryWithStatesList,
      country,
      countrySpecificStatesList,
      state,
      city,
      timezone,
    };

    return (
      <main>
        <NavigationBar />
        {(loadings['isFetchingProfile'] || loadings['isFetchingCountries']) && (
          <LinearProgress />
        )}
        <Container maxWidth='sm' component='section'>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <h3>User Profile</h3>
            </Grid>
            {successes['form'] && successes['form'].length !== 0 && (
              <FormMessageDisplay message={successes['form']} />
            )}
            {errors['form'] && errors['form'].length !== 0 && (
              <FormMessageDisplay message={errors['form']} isError={true} />
            )}
            <Profile
              errors={errors}
              onChange={this.onChange}
              updateProfileClicked={this.updateProfileClicked}
              classes={classes}
              loadings={loadings}
              {...profileStates}
            />
          </Grid>
        </Container>
      </main>
    );
  }
}

export default withStyles(styles)(ProfilePage);
